import { useMemo } from "react";
import RetroAdjustementModal from ".";
import { useVisible } from "../../../../../utils/hooks/useVisible";

export const useRetroAdjustmentModal = () => {
    const { visible, close, open, selected } = useVisible();

    const modal = useMemo(() => {
        return (
            <RetroAdjustementModal
                visible={visible}
                close={close}
                selected={selected}
            />
        )
    }, [close, selected, visible]);

    return { open, modal };
}
